import * as React from "react";
import styled from "styled-components";
import {
  ConstBreakPoint,
  ConstColor,
  ConstMargin,
} from "../../../../config/styles_const/styles_const";

interface IProps
  extends React.DetailedHTMLProps<
    React.TdHTMLAttributes<HTMLTableDataCellElement>,
    HTMLTableDataCellElement
  > {}

const TdDefault: React.FC<IProps> = (props) => {
  const { children, ...TdProps } = props;

  return <td {...TdProps}>{children}</td>;
};

const Td = styled(TdDefault)`
  // border-top: ${ConstMargin.TableBorder} solid ${ConstColor.White};
  // border-bottom: ${ConstMargin.TableBorder} solid ${ConstColor.White};
  background-color: ${ConstColor.TableTd};
  padding: 10px;
  display: block;
  width: 100%;
  white-space: pre-wrap;
  // margin-bottom: -${ConstMargin.TableBorder};
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    display: table-cell;
    padding: 13px 20px;
    margin-bottom: 0;
  }
`;

export default Td;



// WEBPACK FOOTER //
// ./src/presentation/common/atom/table/td.tsx